module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-root",
    class: {
      'bg-change': _vm.tabBgChange
    },
    on: {
      "mouseover": _vm.hoverMiss
    }
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "logo",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goIndex($event)
      }
    }
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require("@/assets/images/logo_chinese.svg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "other"
  }, [_c('div', {
    staticClass: "menu"
  }, _vm._l((_vm.$t('messages.tab')), function(menu, index) {
    return _c('div', {
      key: index,
      ref: ("menu" + index),
      refInFor: true,
      staticClass: "menu-item",
      class: {
        'hover-item': _vm.hoverNum === index
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.goPage(menu, 0)
        },
        "mouseover": function($event) {
          $event.stopPropagation();
          _vm.hoverMenu(index, menu)
        },
        "mouseleave": function($event) {
          $event.stopPropagation();
          return _vm.hoverMiss($event)
        }
      }
    }, [_c('span', {
      class: {
        'isunselect': !_vm.tabItem.cn || (_vm.tabItem.cn && menu.title !== _vm.tabItem.cn && menu.title !== _vm.tabItem.en)
      }
    }, [_vm._v("\n                    " + _vm._s(menu.title) + "\n                ")]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "dialog-show"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hoverNum === index),
        expression: "hoverNum === index"
      }],
      staticClass: "second-dialog",
      class: {
        'second-dialog-en': _vm.getLang() !== 'zh-CN'
      },
      on: {
        "mouseleave": function($event) {
          $event.stopPropagation();
          return _vm.hoverMiss($event)
        }
      }
    }, _vm._l((_vm.hoverItem.children), function(second, index) {
      return _c('div', {
        key: index,
        staticClass: "second-item",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.goPage(_vm.hoverItem, index)
          }
        }
      }, [_c('span', {
        class: {
          unselect: !_vm.tabItem.cn || (_vm.tabItem.cn && _vm.secondPage.cn !== second && _vm.secondPage.en !== second)
        }
      }, [_vm._v(_vm._s(second) + "\n                          ")])])
    }))])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "lang"
  }, [_c('div', {
    staticClass: "en lang-text",
    class: {
      'choose-lang': _vm.$i18n.locale !== 'zh-CN'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.changeLang('en-US')
      }
    }
  }, [_vm._v("\n              EN\n            ")]), _vm._v("\n              "), _c('div', {
    staticClass: "interval"
  }), _vm._v("  \n\n            "), _c('div', {
    staticClass: "cn lang-text",
    class: {
      'choose-lang': _vm.$i18n.locale === 'zh-CN'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.changeLang('zh-CN')
      }
    }
  }, [_vm._v("\n              中\n            ")])]), _vm._v(" "), _c('a', {
    staticClass: "bs-btn",
    attrs: {
      "href": "http://bs.ai.sjtu.edu.cn/",
      "target": "_blank"
    }
  }, [_vm._v("预约")]), _vm._v(" "), _c('img', {
    staticClass: "icon-search",
    attrs: {
      "src": require("@/assets/images/search.svg")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchNews($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-menu",
    attrs: {
      "src": require("@/assets/images/menu.svg")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setMapShow($event)
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45018d11","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab-commonality.vue
// module id = 783
// module chunks = 0 8 10 11 12 13 14 15 16